<div class="controls-preview">
  <div class="controls">
    <p>What data would you like to see?</p>
    @if (reportParameterFormService) {
      <ndt-tile-layout-configurations
        [formService]="reportParameterFormService"
        [tileConfig]="previewTileConfig"
        (tileSetTypeChange)="onTileSetTypeChange($event)"
        (tileLayoutConfigurationsInitialized)="onTileLayoutConfigurationsInitialized()"
      ></ndt-tile-layout-configurations>
      <ndt-report-parameters-list
        [formService]="reportParameterFormService"
        (formChange)="onReportParametersFormChange()"
      ></ndt-report-parameters-list>
    }
  </div>
  <div class="preview">
    <p>Preview</p>
    <div class="preview-wrapper">
      <lcs-loading-overlay [show]="previewTileData?.callState | lcsCallState : 'loading'">
        @if (previewTileConfig) {
          <ndt-tile-wrapper
            [tileConfig]="previewTileConfig"
            [showHeader]="false"
            [isPreview]="true"
            ></ndt-tile-wrapper
            >
          }</lcs-loading-overlay>
        </div>
      </div>
    </div>

    <div class="form-buttons">
      <button type="button" mat-raised-button color="primary" (click)="onBack()"> Back </button>
      <button type="button" mat-raised-button color="primary" [disabled]="isLoading" (click)="onSubmit()"> Add </button>
    </div>
